// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__70BmZ","content":"Modal_content__1gCCE","closeBtn":"Modal_closeBtn__3lzZc","mobile":"Modal_mobile__lcjT0","desktop":"Modal_desktop__mGTX9"};